import { DetailedHTMLProps, ReactNode, HTMLAttributes } from "react";
import { cn } from "../../lib/utils";

interface Props
  extends DetailedHTMLProps<
    HTMLAttributes<HTMLParagraphElement>,
    HTMLParagraphElement
  > {
  children: ReactNode;
  className?: string;
}

export const TypographyBase = ({ children, className, ...props }: Props) => {
  return (
    <p className={cn("text-base", className)} {...props}>
      {children}
    </p>
  );
};
